import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Route";
// import 'bootstrap/dist/css/bootstrap.min.css';  
import 'simplebar-react/dist/simplebar.min.css';
import '../public/assets/css/style.css';
import "./scss/style.scss";
import "./scss/responsive.scss";
import Loader from "./Components/Loader/Loader";
import { ApiProvider } from "./Contexts/ApiContext";
import { QueryProvider } from "./Contexts/QueryProvider";

function App() {

    return (
        <Suspense fallback={<Loader />}>
            <QueryProvider>
                <ApiProvider>
                    <BrowserRouter basename="/">
                        <Routes />
                    </BrowserRouter>
                </ApiProvider>
            </QueryProvider>
        </Suspense>
    )
}

export default App
